import React from 'react'
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import Perfilprodutor from './../img/perfilprodutor.png'
import Imagemrodapeprodutor from './../img/imagemrodapeprodutor.png' 

const theme = createTheme({
  palette: {
    primary: {
      main: '#2e7d32', // Verde agrícola
      light: '#60ad5e',
      dark: '#005005',
      contrastText: '#fff'
    },
    secondary: {
      main: '#f57c00', // Laranja merenda
      light: '#ffad42',
      dark: '#bb4d00',
      contrastText: '#fff'
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff'
    }
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600
    },
    h5: {
      fontWeight: 600
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          padding: '10px 24px'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {         
          // boxShadow:'none', marginLeft:'2rem' 
        },
      },
    },
  }
})

export const ThemeProvider = ({ children }) => {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}      
    </MuiThemeProvider>
  )
}

